import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getOfflineCourseList
} from "../../api/service.js"
import {
  getUnderlineCourseDetail
} from '../../apiCloud/offlineCourseDetail'
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      value5: 3.7,
      courseId: '',
      courseContent: '',
      courseName: '',
      coursePic: '',
      courseSaleprice: '',
      courseTeacher: '',
      openingEnd: '',
      openingStart: '',
      registerCount: '',
      isJx: false,
    }
  },
  created() {
    if (this.$route.query.courseId) {
      localStorage.setItem("courseId", this.$route.query.courseId)
    }
    this.courseId = localStorage.getItem("courseId")
    this.getCourseDetail()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
  },
  mounted() {
    var publicCourse = document.getElementsByClassName("offlineDetailBox")[0]
    publicCourse.style.minHeight = document.body.scrollHeight - 90 + "px"
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/offlineCourseList",
      });
    },
    offlineApply() {
      this.$router.push({
        path: "/offlineApply",
        query: {
          courseId: this.courseId,
        }
      });
    },
    getCourseDetail() {
      let data = {
        courseId: this.courseId,
        entpId: localStorage.getItem("enterpriseId")
      }
      getUnderlineCourseDetail(data).then(res => {
        if (res.code == 200) {
          this.courseContent = res.data.courseContent ? res.data.courseContent : '暂无'
          this.courseName = res.data.courseName
          this.coursePic = res.data.coursePic
          this.courseSaleprice = res.data.courseSaleprice
          this.courseTeacher = res.data.courseTeacher
          this.openingEnd = res.data.openingEnd
          this.openingStart = res.data.openingStart
          this.registerCount = res.data.registerCount
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/offlineCourseDetail/offlineCourseDetail.js